import React, { useState, lazy } from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function ClientsSection() {
  const [activeTab, setActiveTab] = useState<'specialists' | 'companies'>('companies');
  const {
    t,
    language
  } = useLanguage();
  const getLink = (path: string) => `/${language}${path}`;
  // Get items from translations
  const specialistsServices = t('clients.specialistItems');
  const companiesServices = t('clients.companyItems');
  const currentServices = activeTab === 'specialists' ? specialistsServices : companiesServices;
  return <section id="services" className="w-full py-16 px-6 md:px-12 bg-[var(--color-dark)]" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        {/* Services pill */}
        <div className="inline-block px-4 py-1.5 border border-gray-500 rounded-full mb-8" data-id="element-13">
          <span className="text-sm font-medium text-white" data-id="element-14">
            {t('clients.pill')}
          </span>
        </div>

        <div className="flex flex-col lg:flex-row gap-12" data-id="element-15">
          {/* Left side */}
          <div className="lg:w-2/5 flex flex-col" data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight whitespace-pre-line" data-id="element-17">
              {t('clients.title')}
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-18">
              {t('clients.desc1')}
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mb-8" data-id="element-19">
              {t('clients.desc2')}
            </p>

            {/* World Map Image - Balanced position */}
            <div className="relative w-full mt-8" data-id="element-20">
              <div className="w-full h-40 opacity-20 rounded-lg" style={{
              background: 'radial-gradient(circle at 30% 50%, var(--color-teal) 1px, transparent 1px), radial-gradient(circle at 50% 30%, var(--color-teal) 1px, transparent 1px), radial-gradient(circle at 70% 60%, var(--color-teal) 1px, transparent 1px), radial-gradient(circle at 20% 70%, var(--color-teal) 1px, transparent 1px), radial-gradient(circle at 80% 40%, var(--color-teal) 1px, transparent 1px), radial-gradient(circle at 45% 55%, var(--color-teal) 0.5px, transparent 0.5px)',
              backgroundSize: '100% 100%'
            }} aria-hidden="true" data-id="element-21" />
            </div>
          </div>

          {/* Right side - White card with tabs */}
          <div className="lg:w-3/5" data-id="element-22">
            {/* Centered Tab Switcher */}
            <div className="flex justify-center mb-6" data-id="element-23">
              <div className="bg-gray-700/50 p-1.5 rounded-xl inline-flex gap-1" data-id="element-24">
                <button onClick={() => setActiveTab('companies')} className={`px-6 py-2.5 text-sm font-medium rounded-lg transition-all whitespace-nowrap ${activeTab === 'companies' ? 'bg-[var(--color-tan)] text-white shadow-lg' : 'text-gray-300 hover:text-white'}`} data-id="element-25">
                  {t('clients.tabCompanies')}
                </button>
                <button onClick={() => setActiveTab('specialists')} className={`px-6 py-2.5 text-sm font-medium rounded-lg transition-all whitespace-nowrap ${activeTab === 'specialists' ? 'bg-[var(--color-tan)] text-white shadow-lg' : 'text-gray-300 hover:text-white'}`} data-id="element-26">
                  {t('clients.tabSpecialists')}
                </button>
              </div>
            </div>

            {/* Services list card */}
            <div className="bg-white rounded-2xl p-6 md:p-8" data-id="element-27">
              <div className="space-y-6" data-id="element-28">
                {currentServices.map((service: any) => <div key={service.id} className="border-b border-gray-100 pb-6 last:border-0 last:pb-0" data-id="element-29">
                    <div className="flex gap-4" data-id="element-30">
                      <span className="text-[var(--color-tan)] font-medium text-sm flex-shrink-0" data-id="element-31">
                        {service.id}
                      </span>
                      <div className="flex-1" data-id="element-32">
                        <h3 className="text-base font-semibold text-[var(--color-text-dark)] mb-1" data-id="element-33">
                          {service.title}
                        </h3>
                        <p className="text-sm text-[var(--color-text-light)]" data-id="element-34">
                          {service.desc}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>

              {/* Learn More Button - Centered with link */}
              <div className="mt-8 pt-6 border-t border-gray-100 flex justify-center" data-id="element-35">
                <a href={getLink(activeTab === 'specialists' ? '/specialists' : '/companies')} className="inline-flex items-center gap-2 px-6 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity" data-id="element-36">
                  {activeTab === 'specialists' ? t('clients.learnMoreSpecialists') : t('clients.learnMoreCompanies')}
                  <ArrowRight className="w-4 h-4" data-id="element-37" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}